import { agentFragment } from './fragmentsAgent';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const agentQueryAtom = createQueryAtomFactory(
  'admin.agent',
  (params: { id: string }) => ({
    agent: {
      __args: {
        id: params.id,
      },
      ...agentFragment,
    },
  }),
  {
    select: ({ agent }) => agent,
  },
);
